import { Component, Mixins } from 'vue-property-decorator';
import AccountSettings from '@/mixins/accountSettings.mixin';
import applicationStore from '@/store/modules/applications/applicationStore';
import cart from '@/store/modules/checkout/cart/module';

@Component({
  components: {

  }
})
export default class ApplicationInformation extends Mixins(AccountSettings) {

  /* istanbul ignore next */
  get applicationData() {
    return applicationStore.applicationDataInfo;
  }

  get isLoadingCartApplicationsData() {
    return cart.isLoadingCartApplicationsData;
  }
}